import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import BatchInvoiceSummary from "./batch-invoice-summary.model";

export default class BatchInvoiceSummaryFactory
  implements ObjectBuilderInterface<BatchInvoiceSummary> {
  public buildFromJSON(data: { [key: string]: any }): BatchInvoiceSummary {
    const value = new BatchInvoiceSummary(
      data.id,
      this.getOptionalString(data.incrementalId),
      new Date(data.createdAt),
      data.factoryId,
      +data.itemsQty,
      +data.total,
      data.status,
      +data.type,
      this.getOptionalNumber(data.usedDepositPercent),
      data.batchPlushieId,
      data.bulkProjectId,
      this.getOptionalString(data.bulkProjectSku),
      this.getOptionalString(data.batchPlushieSku)
    );

    value.isNew = false;

    return value;
  }

  private getOptionalString(value: any): string | undefined {
    if (value === undefined || value === null) {
      return undefined;
    }

    return String(value);
  }

  private getOptionalNumber(value: any): number | undefined {
    if (value === undefined || value === null) {
      return undefined;
    }

    return +value;
  }
}
